import { requestGet, requestPost, requestPostFile } from "../config/Api";

// Sube 1..N archivos .json del outbox/ordenes-pago del exportador local
// (o un .zip que los contenga). data: FormData con files[] (o file).
export const uploadPaymentOrderImports = (data) => {
  return requestPostFile("payment/order/import", data);
};

export const getPaymentOrderImports = (params = {}) => {
  return requestGet("payment/order/import", params);
};

export const getPaymentOrderImport = (id) => {
  return requestGet(`payment/order/import/${id}`);
};

export const retryPaymentOrderImport = (id) => {
  return requestPost(`payment/order/import/${id}/retry`);
};
